import { NumberField } from '@base-ui/react/number-field';

import { Icon } from '../Icon';
import styles from './InputNumber.module.css';

export type InputNumberSize = 'large' | 'default' | 'small';

export interface InputNumberProps {
  ariaLabel: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  max?: number;
  min?: number;
  name?: string;
  onValueChange: (value: number | null) => void;
  placement?: 'default' | 'right';
  size?: InputNumberSize;
  step?: number;
  /**
   * 步进按钮只在鼠标移到整组上（或键盘聚焦）时现身，静态只剩数字本身。
   * 用在表格行内这种「平时当纯文本读、要用才露控件」的场景，与页面里其他字段的三态一致。
   */
  steppersOnHover?: boolean;
  value: number | null;
}

export function InputNumber({ ariaLabel, className, disabled, id, max, min, name, onValueChange, placement = 'default', size = 'default', step = 1, steppersOnHover = false, value }: InputNumberProps) {
  return (
    <NumberField.Root className={styles.root} data-size={size} data-steppers={steppersOnHover ? 'hover' : 'always'} disabled={disabled} id={id} max={max} min={min} name={name} onValueChange={(nextValue) => onValueChange(nextValue)} step={step} value={value}>
      <NumberField.Group className={[styles.group, className].filter(Boolean).join(' ')}>
        {placement === 'default' ? <NumberField.Decrement aria-label={`减少${ariaLabel}`} className={styles.stepper} data-icon="minus"><Icon name="minus" size="sm" /></NumberField.Decrement> : null}
        <NumberField.Input aria-label={ariaLabel} className={styles.input} />
        {placement === 'default' ? <NumberField.Increment aria-label={`增加${ariaLabel}`} className={styles.stepper} data-icon="plus"><Icon name="plus" size="sm" /></NumberField.Increment> : null}
        {placement === 'right' ? (
          <span className={styles.rightSteppers}>
            <NumberField.Increment aria-label={`增加${ariaLabel}`} className={styles.rightStepper}>
              <Icon name="a-arrow-up" size="xs" />
            </NumberField.Increment>
            <NumberField.Decrement aria-label={`减少${ariaLabel}`} className={styles.rightStepper}>
              <Icon name="a-arrow-down" size="xs" />
            </NumberField.Decrement>
          </span>
        ) : null}
      </NumberField.Group>
    </NumberField.Root>
  );
}
